"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var modules_1 = require("@dynamynd/modules");

var responsive_1 = require("@dynamynd/responsive");

var styled_components_1 = __importDefault(require("styled-components"));

var ContentRowFixer = styled_components_1.default(modules_1.ContentRow)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 60px;\n"], ["\n    margin-top: 60px;\n"])));
exports.default = responsive_1.withResponsiveMeta(ContentRowFixer);
var templateObject_1;